const UPDATES = [
  {
    id: 1,
    title: '《热辣滚烫》高清版正式上线',
    desc: '贾玲导演力作，票房口碑双丰收，4K超清画质已同步更新。',
    time: '2024年7月28日',
    tag: '新片上线',
  },
  {
    id: 2,
    title: '《繁花》全集4K修复版更新完成',
    desc: '王家卫导演年代大剧，沪语原声版与普通话版同步上架。',
    time: '2024年7月25日',
    tag: '剧集更新',
  },
  {
    id: 3,
    title: '平台播放引擎全面升级',
    desc: '采用新一代视频加速技术，缓冲速度提升40%，画质更清晰。',
    time: '2024年7月20日',
    tag: '平台公告',
  },
  {
    id: 4,
    title: '暑期档热门影片专题上线',
    desc: '精选暑期院线热映影片与经典暑期档回顾，一站式观影指南。',
    time: '2024年7月15日',
    tag: '专题上线',
  },
  {
    id: 5,
    title: '《第二十条》导演剪辑版独家上线',
    desc: '张艺谋导演律政题材力作，新增30分钟未公开内容。',
    time: '2024年7月10日',
    tag: '新片上线',
  },
  {
    id: 6,
    title: '移动端观影体验优化升级',
    desc: '适配更多设备分辨率，流量节省模式让移动观影更省心。',
    time: '2024年7月5日',
    tag: '体验优化',
  },
  {
    id: 7,
    title: '韩剧专题频道全新改版',
    desc: '热门韩剧一站式聚合，高分经典与最新热播全覆盖。',
    time: '2024年6月28日',
    tag: '专题上线',
  },
  {
    id: 8,
    title: '动漫频道资源扩容2000+',
    desc: '日漫、国漫、欧美动画全面补全，经典番剧高清修复版上线。',
    time: '2024年6月20日',
    tag: '内容更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-600">平台更新与内容上线实时同步</p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-background-300"></div>

            <div className="space-y-5">
              {UPDATES.map((item) => (
                <div key={item.id} className="relative pl-10 md:pl-14">
                  <div className="absolute left-2.5 md:left-[19px] top-2 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>

                  <div className="bg-background-50 border border-background-200 rounded-xl p-4 md:p-5">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded whitespace-nowrap">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}